/**
 * 夜間に通知音を鳴らさない時間帯の言い方（「22:00〜翌7:00」・issue #434）。
 *
 * 時の頭の0は付けず、日付をまたぐときは終わりに「翌」を付ける。
 * サーバの案内（server/src/announcements/text.ts の quietHoursLabel）・アプリの設定の画面と同じ言い方にそろえる。
 */
export function quietHoursLabel(window: { start: string; end: string }): string {
  const trim = (time: string) => time.replace(/^0(\d)/, '$1');
  const overnight = window.start > window.end;
  return `${trim(window.start)}〜${overnight ? '翌' : ''}${trim(window.end)}`;
}

/** 確認の窓・送ったあとに添える1文（いまは夜間なので、通知音は鳴らない）。 */
export function quietHoursNowSentence(window: { start: string; end: string }): string {
  return `いまは夜間の時間帯（${quietHoursLabel(window)}）なので、通知音は鳴りません。`;
}
